import { db, type MessageEntity } from "src/db";
import { deleteAPI } from "./fetch";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export const deleteChat = async (chatId, openedChatId, instance, navigate) => {
    const response = await deleteAPI({
        url: `${BACKEND_URL}/v1/user/conversations/${chatId}`,
        instance,
    });

    if (!response?.ok) {
        throw new Error("Failed to delete chat");
    }

    await db.chats.where({ id: chatId }).delete();
    await db.messages.where({ chatId }).delete();

    if (chatId === openedChatId) {
        navigate({ to: "/" });
    }
};

export const deleteAllChats = async (instance, navigate) => {
    // No conversation id: the backend clears every conversation for the user.
    // Trailing slash is required — the backend returns 405 for DELETE without it.
    const response = await deleteAPI({
        url: `${BACKEND_URL}/v1/user/conversations/`,
        instance,
    });

    if (!response?.ok) {
        throw new Error("Failed to delete chats");
    }

    await db.chats.clear();
    await db.messages.clear();
    navigate({ to: "/" });
};

export const deleteResponse = async (message: MessageEntity, instance, navigate) => {
    const chatId = message.chatId;
    const responseId = message.responseId;
    const messagesCount = (await db.messages.where({ chatId }).toArray()).length;

    if (messagesCount === 2) {
        // Delete chat
        return await deleteChat(chatId, chatId, instance, navigate);
    }
    const response = await deleteAPI({
        url: `${BACKEND_URL}/v1/user/conversations/${chatId}/responses/${responseId}`,
        instance,
    });
    if (!response?.ok) {
        throw new Error("Failed to delete response");
    }

    const ids = [message.id];
    if (message.repliedId) ids.push(message.repliedId);
    for (const id of ids) {
        await db.messages.where({ id }).delete();
    }
};
